import React from "react";
import R14, {
  StyleSheet,
  Text,
  View,
  Image
} from "../core";
import Touchable from "../components/TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import CopyRight from "../components/CopyRight";
import MyBankListComponent from "../components/MyBankListComponent";
import JsonToCSV from "../utils/JsonToCSV";
import HtmlDecode from "../utils/HtmlDecode";
import DateUtils from "../utils/DateUtils";

import attachedFileIcon from "../assets/images/attachedFileIcon.png";

export default R14.connect(
  class MyBanksScreen extends React.Component {

    convertToCSV = async(items, screenName = "data") => {
      if (items.length){
        items = items.map(item => {
          return {
            "Biller Name": item.billerName,
            "Bank Name": item.bankName,
            "Account#": item.accountNumber,
            "Routing#": item.routingNumber,
            "Verification Status": item.verificationStatus,
          }
        })
        const csvContent = JsonToCSV.convertJsonToCSV(items);
        HtmlDecode.downloadUTF8file({
          content: csvContent,
          filename: `${screenName}_${DateUtils.formatYYYYMMDDHHMMSS()}.csv`
        })
      }
      return false;
    }

    renderPageTitleSection() {
      return (
        <View style={[styles.pageTitleHolder]}>
          <Text style={[commonStyles.titleTextHeader1, commonFontStyles.workSans]}>
            {this.props.r14.navigation.currRoute._config.label}{" "}
          </Text>
          <View style={[]}>
            <Touchable onPress={() => this.convertToCSV(this.props.payerBankAccounts, "My Banks")}>
              <Image source={attachedFileIcon} style={commonStyles.icon18} />
            </Touchable>
          </View>
        </View>
      );
    }

    render() {
      return (
        <>
            <View style={[styles.container, commonStyles.dashboardScrollView, commonStyles.flex1]}>
              {this.renderPageTitleSection()}
              <MyBankListComponent  payerBankAccounts={this.props.payerBankAccounts}/>
            </View>
              <View style={[ commonStyles.textAlignCenter, commonStyles.copyRightWrapper]}>
                <CopyRight />
              </View>
        </>
      );
    }
  }
);

const styles = StyleSheet.create({
  profileViewScreen: {
    padding: 15,
    margin: 0,
    height: "100%",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          backgroundColor: "#f4f4f4",
        };
      }
      if (width <= 640) {
        return {
          margin: 0,
          paddingBottom: 20
        };
      }
    },
  },
  pageTitleHolder: {
    zIndex: 999,
    paddingTop: 7,
    paddingRight: 16,
    paddingBottom: 10,
    paddingLeft: 16,
    backgroundColor: "#f4f4f4",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexGrow: 0,
    maxHeight: 45,
  },
  container: {
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          backgroundColor: "white",
        };
      }
    },
  }
});
